/**
 * Скрипты страницы товара
 */
(function($){

	// Cлайдер-галерея товара
	var productGallery = new Swiper('.product-page-gallery', {
		pagination: {
			el: '.product-page-gallery-pagination',
			clickable: true
		},
	});

	// Изменение кол-ва в счетчике
	$('.product-page-counter input').change(function(){
		var totalSum = +$('.product-page-price').data('price') * +this.value;
		$('.product-page-total-value').html( totalSum.toLocaleString('ru-RU') );
		$('.product-page-add-to-cart').attr('data-quantity', this.value);
	});

})(jQuery);